import { render, staticRenderFns } from "./PatientLandingPage.vue?vue&type=template&id=528bc127&"
import script from "./PatientLandingPage.vue?vue&type=script&lang=js&"
export * from "./PatientLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports